import { defineComponent as _defineComponent } from 'vue'
import {nextTick, onMounted, ref} from 'vue';
import {textParse, publishSupply, updateSupply} from '@/api/miscellaneous';
import CityPicker from '@/components/CityPicker.vue';
import Specifications from './Specifications.vue';
import type {SupplyData} from './type';
import {upload} from '@/libs/upload';
import {uploadVideo} from '@/libs/uploadVideo';
import {Toast} from 'vant';
import {captureVideoCover, base64toFile} from '@/libs/utils';
import userStoreModule from '@/store/modules/user';
import router from '@/router';
import VarietiesSearch from '@/components/VarietiesSearch.vue';
import type {ToastWrapperInstance} from 'vant/lib/toast/types';
import {editHook} from '@/views/ReleaseSupply/edit.hook';
import {useRoute} from 'vue-router';
import Upload from '@/components/Upload/Upload.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReleaseSupply',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const stepActive = ref(0);
const textValue = ref(
    // '供应桂花，数量100棵，高度150-200cm，冠幅150- 200cm，胸径40-50cm，供苗地浙江省金华市。供应国槐，数量100棵，高度150-200cm，冠幅150- 200cm，胸径40-50cm，供苗地浙江省金华市',
    '',
);
const list = ref<any>([]);
const dataList = ref<SupplyData[]>([]);
const isShowCityPicker = ref(false);
const cityPickerIndex = ref(0);
const uploadIndex = ref(0);
const isSpecificationsShow = ref(false);
const specificationsIndex = ref(0);
const videoImg = ref<any[]>([]);

const isSelectSearch = ref(false);
const selectVarietiesIndex = ref(0);

const id = ref(route.query.id);

const isPickerShow = ref(false);
const pickerIdx = ref(0);
const pickerListIdx = ref(0);
const submitLoading = ref(false);

onMounted(async () => {
    let {location = {lat: 0, lon: 0}, address, areaId, shortAddress} = userStoreModule.userDetail,
        {lat, lon} = location;
    attributes.longitude = lon;
    attributes.latitude = lat;
    attributes.address = shortAddress;
    attributes.areaId = areaId;

    if (id.value) {
        initEdit();
    } else {
        /**
         * @time 2022/012/03
         * @description 改回没有文本解析版本
         * */
        stepActive.value = 1;
        list.value = [{imgList: []}];
        dataList.value = [attributes];
    }
});
const attributes: SupplyData = {
    longitude: 0,
    latitude: 0,
    categoryId: 0,
    title: '',
    quantity: '',
    profile: '',
    rotation: 0,
    areaId: '',
    video: [],
    minPrice: '0',
    maxPrice: '0',
    address: '',
    photos: [],
    specifications: '[]',
    quality: '0',
    price: 0,
};
const text = ref(`请复制粘贴`);

const parseText = () => {
    if (!textValue.value) {
        stepActive.value = 1;
        list.value = [{imgList: [], data: {}}];
        dataList.value = [attributes];
        return;
    }

    textParse({keywords: textValue.value}).then(res => {
        let supplyData = (res as any[]).map((el: {name: any; id: any; profile: any}) => {
            return {
                ...attributes,
                ...{
                    title: el.name,
                    categoryId: el.id,
                    profile: el.profile || '',
                },
            };
        });
        list.value = (res as any[]).map(el => ({...el, imgList: []}));
        stepActive.value = 1;
        dataList.value = supplyData;
    });
};

const confirmCity = (val: any[]) => {
    dataList.value[cityPickerIndex.value].areaId = val[val.length - 1].value as string;
    dataList.value[cityPickerIndex.value].address = Array.from(new Set(val.map((el: {label: string}) => el.label))).join('');
};

const imgAfterRead = (file: any) => {
    // dataList.value[cityPickerIndex.value].photos.push(file);
    if (!Array.isArray(file)) file = [file];
    let imgUploads = Promise.all(file.map((el: any) => upload({type: 'supply', obj: el})));
    let uploading = Toast.loading({
        message: '图片上传中...',
        duration: 0,
        overlay: true,
    });
    imgUploads.then(res => {
        const photos = res.map((el: any) => el.url);
        list.value[uploadIndex.value].imgList = [...list.value[uploadIndex.value].imgList, ...res];
        dataList.value[uploadIndex.value].photos = [...dataList.value[uploadIndex.value].photos, ...photos];
        uploading.clear();
    });
};

const confirmSpecifications = (str: string) => {
    dataList.value[specificationsIndex.value].specifications = str;
};
let uploading: ToastWrapperInstance;
const video = ref<any>(null);
const videoAfterRead = (file: any) => {
    uploading = Toast.loading({
        message: '视频上传中...',
        duration: 0,
        overlay: true,
    });
    captureVideoCover(file.file).then(videoImage => {
        const imgFile = base64toFile(videoImage as string, `${new Date().getTime()}Img`);
        const httpRequests = Promise.all([
            upload({type: 'supply', obj: {file: imgFile, content: videoImage}}),
            uploadVideo({type: 'supply', obj: file}),
        ]);
        httpRequests.then(res => {
            dataList.value[uploadIndex.value].video = [res[1].url];
            videoImg.value[uploadIndex.value] = res[0];
            uploading.message = '正在解析图片...';
        });
    });
};
const videoImgLoad = () => {
    uploading.message = '解析图片成功...';
    uploading.clear();
};

const onsubmit = (idx: number) => {
    if (!list.value[idx].data?.length) return Toast('请选择品种');
    dataList.value[idx].specifications = attributesToString(idx);
    if (dataList.value[idx].photos.length === 0 && dataList.value[idx].video.length != 0) {
        dataList.value[idx].photos = [videoImg.value[idx].url];
    }
    submitLoading.value = true;
    try {
        if (!id.value) {
            publishSupply(dataList.value[idx])
                .then(res => {
                    list.value[idx].isRelease = true;
                    submitLoading.value = false;
                    if (list.value.every((el: {isRelease: boolean}) => el.isRelease)) {
                        router.push({name: 'Result', query: {type: 'supply'}});
                    } else {
                        Toast.success('发布成功');
                    }
                })
                .catch(() => {
                    submitLoading.value = false;
                });
        } else {
            updateSupply(dataList.value[idx], id.value as string)
                .then(res => {
                    Toast.success('保存成功');
                    submitLoading.value = false;
                    setTimeout(() => {
                        router.back();
                    }, 1000);
                })
                .catch(() => {
                    submitLoading.value = false;
                });
        }
    } catch (e) {
        submitLoading.value = false;
    }
};

const deleteImg = (idx: number, imgIdx: number) => {
    list.value[idx].imgList.splice(imgIdx, 1);
    dataList.value[idx].photos.splice(imgIdx, 1);
};

const deleteVideo = (idx: number) => {
    videoImg.value[idx] = '';
    dataList.value[idx].video = [];
};

/**
 *@description 确认选择分类的callback
 * @param val 选中的品种的属性列表
 * @param data 当前选择的选中的品种
 */

const confirmVarieties = (val: any, data: any) => {
    setData(val);
    list.value[selectVarietiesIndex.value].attributeObject = val;
    list.value[selectVarietiesIndex.value].id = data.id || data.categoryId;
    list.value[selectVarietiesIndex.value].name = data.name || data.categoryName;
    dataList.value[selectVarietiesIndex.value].categoryId = data.id || String(data.categoryId);
    isSelectSearch.value = false;
};

/**
 * @description: 初始化编辑数据
 * */
const initEdit = () => {
    const edit = editHook(route.query.id as string);
    edit.then(({detail, data, lists}) => {
        stepActive.value = 1;
        list.value = lists;
        setData(lists[0].attributeObject, detail.value.specifications);
        dataList.value = [
            {
                ...attributes,
                ...data,
            },
        ];
    });
};

/**
 *@description: 选择品种后设置Input输入绑定的数据
 * @param {array} val 选择的品种的属性列表
 * @param {string} value 选择的品种的的值
 * */

const setData = (val: any, value = '') => {
    const valueData = value ? JSON.parse(value) : [];
    let specificationData = val.map((el: any) => {
        const {name, id, unit, attributeType} = el;
        const val = valueData.find((item: any) => item.id === id)?.value || '';
        let value: string | (string | number | null)[] = '';
        switch (attributeType) {
            case 'range':
                value = val || [];
                break;
            case 'select':
                value = val || '';
                break;
        }
        return {name, id, unit, value};
    });
    list.value[specificationsIndex.value].data = specificationData;
};

/**
 * @description: 将选择的品种属性转换成字符串
 * @param {number} idx 选择的品种的索引
 * */
const attributesToString = (index: number) => {
    return JSON.stringify(
        list.value[index].data.filter((el: {value: string | any[]}) => {
            //@ts-ignore
            if (Array.isArray(el.value)) {
                return el.value.length;
            } else {
                return el.value;
            }
        }),
    );
};

const pickerColumns = (str: string) => {
    return JSON.parse(str);
};

const confirmPicker = (val: any) => {
    list.value[pickerListIdx.value].data[pickerIdx.value].value = val.value;
    isPickerShow.value = false;
};

const minChange = (idx: number, itemIdx: number) => {
    const val = list.value[idx].data[itemIdx].value;
    const min = val[0];
    const max = val[1];
    if (!max || Number(min) > Number(max)) {
        list.value[idx].data[itemIdx].value[1] = min;
    }
};

const __returned__ = { route, stepActive, textValue, list, dataList, isShowCityPicker, cityPickerIndex, uploadIndex, isSpecificationsShow, specificationsIndex, videoImg, isSelectSearch, selectVarietiesIndex, id, isPickerShow, pickerIdx, pickerListIdx, submitLoading, attributes, text, parseText, confirmCity, imgAfterRead, confirmSpecifications, uploading, video, videoAfterRead, videoImgLoad, onsubmit, deleteImg, deleteVideo, confirmVarieties, initEdit, setData, attributesToString, pickerColumns, confirmPicker, minChange, nextTick, onMounted, ref, textParse, publishSupply, updateSupply, CityPicker, Specifications, upload, uploadVideo, Toast, captureVideoCover, base64toFile, userStoreModule, router, VarietiesSearch, editHook, useRoute, Upload }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})